
import ApplicationController from '../application_controller.js';
import { Controller } from "stimulus";
import { Janus } from 'janus-gateway';
import {Socket} from "phoenix";
import throttle from 'lodash/throttle';


export default class extends ApplicationController {
  initialize() {
    this.checkStartTime();
  }

  checkStartTime() {
    let self = this;
    setInterval(function() {
      //self.stimulate("LiveCall#full_refresh");
      location.reload()
    }, 60000);

  }

}


